<template>
  <div class="root-component-content" @click="handleComponentClick">
    <top-navbar />
    <div class="content">
      <transition
        :name="transitionName"
        :mode="transitionMode"
        :enter-active-class="transitionEnterActiveClass"
        @beforeLeave="beforeLeave"
        @enter="enter"
        @afterEnter="afterEnter"
    >
        <router-view />
      </transition>
    </div>
    <div class="footer">
      <footer-component />
    </div>
    <jabra-signup></jabra-signup>
    <jabra-thank-you-popup></jabra-thank-you-popup>
    <google-platform></google-platform>
    <facebook-sdk></facebook-sdk>
  </div>
</template>

<script>
const DEFAULT_TRANSITION = 'slide';
const DEFAULT_TRANSITION_MODE = 'out-in';

import {
  SET_LANGUAGE_AND_RELOAD,
  LOGOUT,
  LOG_IN_MODE,
  SIGN_UP_MODE,
  ROUTE_CART,
  SET_SIGNUP_SHOW_STATE,
  SET_SIGNUP_MODE,
  ROUTE_MISHNAYOT,
  ROUTE_ROOT
} from "../services/constants";
import SearchResults from "./non-routed/SearchResults";
import ThankYouPopup from "./non-routed/ThankYouPopup";
import GooglePlatform from "./non-routed/GooglePlatform";
import FacebookSdk from "./non-routed/FacebookSdk";

import helpers from "../services/helpers";
import TopNavbar from "./TopNavbar";
import FooterComponent from "./FooterComponent";

export default {
  name: "root-component",
  props: {
    msg: String
  },
  components: {
    "jabra-search-results": SearchResults,
    "jabra-thank-you-popup": ThankYouPopup,
    "google-platform": GooglePlatform,
    "facebook-sdk": FacebookSdk,
    TopNavbar,
    FooterComponent
  },
  data: function() {
    return {
      prevHeight: 0,
      transitionName: DEFAULT_TRANSITION,
      transitionMode: DEFAULT_TRANSITION_MODE,
      transitionEnterActiveClass: '',
      languageDropdownShowState: false,
      userProfileDropdownShowState: false
    };
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName || DEFAULT_TRANSITION;

      if (transitionName === 'slide') {
        const toDepth = to.path.split('/').length;
        const fromDepth = from.path.split('/').length;
        transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
      }

      this.transitionMode = DEFAULT_TRANSITION_MODE;
      this.transitionEnterActiveClass = `${transitionName}-enter-active`;

      if (to.meta.transitionName === 'zoom') {
        this.transitionMode = 'in-out';
        this.transitionEnterActiveClass = 'zoom-enter-active';
        document.body.style.overflow = 'hidden';
      }

      if (from.meta.transitionName === 'zoom') {
        this.transitionMode = null;
        this.transitionEnterActiveClass = null;
        document.body.style.overflow = null;
      }

      this.transitionName = transitionName;

      next();
    });
  },
  computed: {
    languages: function() {
      return this.$store.state.languageModule.languages;
    },
    currentLanguage: function() {
      return this.$store.state.languageModule.currentLanguage;
    },
    todaysLesson: function() {
      return this.$store.state.todaysLesson;
    },
    loggedInUser: function() {
      return this.$store.state.user.data;
    },
    userDisplay() {
      if (this.loggedInUser) {
        if (this.loggedInUser.firstName && this.loggedInUser.lastName) {
          return `${this.loggedInUser.firstName} ${this.loggedInUser.lastName}`;
        } else {
          return `${this.loggedInUser.emailAddress}`;
        }
      }
      return "";
    },
    routeMishnayot() {
      return {
        name: ROUTE_MISHNAYOT
      };
    },
    routeRoot() {
      return {
        name: ROUTE_ROOT
      };
    }
  },
  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = 'auto';
    },
    openSignup: function() {
      this.userProfileDropdownShowState = false;
      this.$store.commit(SET_SIGNUP_MODE, SIGN_UP_MODE);

      this.$store.commit(SET_SIGNUP_SHOW_STATE, true);
    },
    openLogin: function() {
      this.userProfileDropdownShowState = false;
      this.$store.commit(SET_SIGNUP_MODE, LOG_IN_MODE);
      this.$store.commit(SET_SIGNUP_SHOW_STATE, true);
    },
    closeSignup: function() {
      this.userProfileDropdownShowState = false;
      this.$store.commit(SET_SIGNUP_SHOW_STATE, false);
    },
    logout() {
      this.$store.dispatch(LOGOUT);
      this.$router.push(this.routeRoot);
    },
    handleUserProfileDropdownClick($event) {
      this.languageDropdownShowState = false;
      this.userProfileDropdownShowState = !this.userProfileDropdownShowState;
    },
    handleLanguageDropdownClick($event) {
      this.languageDropdownShowState = !this.languageDropdownShowState;
      this.userProfileDropdownShowState = false;
    },
    handleChangeMode($event) {
      this.$store.commit(SET_SIGNUP_MODE, $event);
    },
    handleComponentClick($event) {
      this.languageDropdownShowState = false;
      this.userProfileDropdownShowState = false;
      // EventBus.$emit('sfr-global-click', $event)
    },
    l10nGetter(key) {
      return helpers.uiTextGetter(this.$store, key);
    }
  }
};
</script>

<style scoped lang="scss">
// @import "../scss/main";

// .root-navbar {
//   background-color: $white-1;
//   padding: 1em 2em;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
// }

// $top-center-section: 120px;
// .navbar-center-section {
//   width: $top-center-section;
// }

// .search-section {
//   flex-grow: 1;
//   @include font-abraham(16px, white, 300);

//   textarea,
//   select,
//   input,
//   button {
//     @include font-abraham(16px, #ffffff, 300);
//     outline: none;
//     background: $font-color-blue;
//     -webkit-appearance: none;
//     border: none;
//     border-bottom: white solid 1px;
//     /*&::placeholder, ::-webkit-input-placeholder, :-ms-input-placeholder, ::-ms-input-placeholder {}*/
//   }
// }

// .navbar-left-section,
// .navbar-right-section {
//   flex-basis: calc(50% - #{$top-center-section / 2});
//   display: flex;
//   @include font-abraham(16px, $font-color-blue, 300);
// }

// .navbar-right-section {
//   justify-content: flex-end;
// }

// .user-profile {
//   cursor: pointer;
// }

// .cart {
//   .count-bubble {
//     position: relative;
//     bottom: 5px;
//     right: 10px;
//   }

//   .cart-svg-circle {
//     fill: $accent-1;
//   }

//   text {
//     fill: white;
//   }

//   &:hover {
//     $cart-hover-transition: fill 0.4s ease;

//     .cart-svg-circle {
//       fill: white;
//       transition: $cart-hover-transition;
//     }

//     text {
//       fill: $accent-1;
//       transition: $cart-hover-transition;
//     }
//   }
// }

// .profile-area {
//   display: flex;
//   justify-content: flex-end;
//   flex-grow: 1;
// }

// .navbar-right-section-child {
//   margin: 0 2em 0 0;
// }

// .user-data-link {
//   cursor: pointer;

//   &:hover {
//     color: $accent-1;
//   }
// }

// .sign-up-button {
//   margin: 0 1em 0 0;
// }

// .language-dropdown-section {
//   cursor: pointer;
//   min-width: 65px;
// }

// .user-profile-dropdown,
// .language-dropdown {
//   position: absolute;
//   z-index: 1;
//   background: white;
//   @include font-abraham(16px, $font-color-blue, 300);
//   border-radius: 1px 1px 5px 5px;
//   border-bottom: $font-color-blue solid 2px;
//   border-left: $font-color-blue solid 2px;
//   border-right: $font-color-blue solid 2px;
// }

// .language-dropdown-option,
// .user-profile-option {
//   padding: 1em;
//   line-height: 20px;

//   &:hover {
//     background: $hover-color-grey;
//   }
// }

// .language-dropdown-option {
//   &.current-language {
//     background: $background-color-grey;
//   }
// }

// .user-text,
// .current-language-text,
// .annual-sponsor-key-text {
//   margin: 0 7px 0 0;
// }

// .in-memory-of-value-text {
//   margin: 0 7px 0 24px;
// }

// .annual-sponsor-key-text {
//   font-weight: 400;
// }

// .second-topbar {
//   padding: 30px 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   position: relative;
//   box-shadow: 0 2px 2px 0 $grey-2;
//   background-color: $accent-2;
//   @include font-abraham(20px, $font-color-blue, 400);
// }

// .second-topbar-content {
//   display: flex;
//   justify-content: center;
//   width: 100%;
// }

// .second-topbar-content-child {
//   flex-basis: 50%;
//   align-items: center;
// }

// .second-topbar-left-section {
//   margin: 0 0 0 1em;
//   display: flex;
//   justify-content: flex-end;
// }

// .second-topbar-left-section-child {
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
//   $left-side-margin: 200px;
// }

// .second-topbar-middle-section {
//   width: $top-center-section;

//   .logo-anchor {
//     position: relative;
//     width: 100%;
//     .logo-wrapper {
//       position: absolute;
//       bottom: -15px;
//       width: 100%;
//       display: flex;
//       justify-content: center;
//       img {
//         cursor: pointer;
//         height: 80px;
//       }
//     }
//   }
// }

// .second-topbar-right-section {
//   display: flex;
//   justify-content: flex-start;
//   margin: 0 1em 0 0;
// }

// .daf-yomi-key {
//   margin: 0 5px 0 0;
// }

// .topbar-link {
//   cursor: pointer;
//   margin: 0 1em;
//   &.daf-yomi-link {
//     color: $accent-1;
//   }
// }

// > .content {
//   background: $background-color-grey;
// }

// .footer {
//   .footer-top {
//     padding: 70px 0 50px;
//     display: flex;
//     justify-content: center;

//     .footer-top-content {
//       width: 100%;
//       margin: 0 3em 0 5em;

//       display: flex;
//       justify-content: space-between;

//       .sedarim {
//         display: flex;

//         .masechet-hashas-section {
//           &.talmud {
//             margin: 0 170px 0 0;
//           }
//           > .header {
//             @include font-abraham(20px, $font-color-blue, 400);
//             line-height: 39px;
//             border-bottom: $font-color-blue solid 1px;
//           }

//           > .content {
//             display: flex;

//             .seder {
//               margin: 0 40px 0 0;

//               > .header {
//                 @include font-abraham(14px, $grey-1, 400);
//                 line-height: 38px;
//                 text-transform: uppercase;
//               }

//               > .content {
//                 .masechet {
//                   @include font-abraham(14px, $grey-1, 400);
//                   line-height: 20px;
//                   cursor: pointer;
//                   a {
//                     text-decoration: none;
//                     color: inherit;
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }

//       .links {
//         margin: 0 0 0 1em;
//         .site-links {
//           padding: 0 0 15px 0;
//           border-bottom: $font-color-blue solid 1px;
//         }

//         .link {
//           @include font-abraham(26px, $font-color-blue, 300);
//           line-height: 40px;
//           cursor: pointer;
//         }

//         .social-media-links {
//           padding: 15px 0 0 0;
//           color: $font-color-blue;

//           .social-media-icon {
//             margin: 0 23px 0 0;
//           }
//         }
//       }
//     }
//   }

//   .footer-bottom {
//     padding: 31px 42px;
//     display: flex;
//     justify-content: space-between;
//     background-color: $font-color-blue;
//     @include font-abraham(12px, white, 400);

//     .signature {
//       span {
//         text-decoration: underline;
//       }
//     }
//   }
// }
// @media only screen and (max-width: 600px) {
//   // .root-component-content > .content {
//   //   padding: 0 10px;
//   // }
//   // .root-navbar,
//   // .footer,
//   // .topbar-link {
//   //   display: none;
//   // }
//   // .second-topbar {
//   //   margin: 44px 0 20px 0;
//   // }
// }
</style>
